import { render } from "./restyle_button.vue?vue&type=template&id=2be5b154&scoped=true"
import script from "./restyle_button.vue?vue&type=script&lang=js"
export * from "./restyle_button.vue?vue&type=script&lang=js"

import "./restyle_button.vue?vue&type=style&index=0&id=2be5b154&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2be5b154"]])

export default __exports__